// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable formatjs/no-literal-string-in-jsx */
import { Typography } from "@carrotfertility/carotene-core"
import React from "react"
import { PageHeader } from "#/features/global-ui/page-header"
import { PageLayout } from "#/features/global-ui/page-layout"
import { Title } from "#/services/page-title/Title"

export function ConsumerHomePage(): JSX.Element {
  const pageTitle = "Your Carrot Plan"
  return (
    <PageLayout variant="default" header={<PageHeader pageTitle={pageTitle} />}>
      <Title title={pageTitle} />
      <Typography>Consumer Your Carrot Plan — coming soon.</Typography>
    </PageLayout>
  )
}
